export default {
    data: () => ({
        translations: {
            title: {
                el: "Τρόπος Δημιουργίας Κουπονιού",
                en: "Coupon Creation",
                it: "Creazione di coupon"
            },
            numericQrCode: {
                el: "Αριθμητικό QR Code",
                en: "Numeric QR Code",
                it: "Codice QR numerico"
            },
            alphanumericQrCode: {
                el: "Αλφαριθμητικό QR Code",
                en: "Alphanumeric QR Code",
                it: "Codice QR alfanumerico"
            },
            numericBarcode: {
                el: "Αριθμητικό Barcode",
                en: "Numeric Barcode",
                it: "Numero numerico del codice a barre"
            }
        }
    })
};
